import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Typography, Box, CircularProgress, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import config from '../../config';
import UserNav from '../../components/UserNav';
// eslint-disable-next-line no-unused-vars
import { Divider } from '@material-ui/core';

const groupByTestType = (results) => {
	const groups = {};
	results.forEach((result) => {
		const type = result.testType || 'Other';
		if (!groups[type]) groups[type] = [];
		groups[type].push(result);
	});
	return groups;
};

const Results = () => {
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const [results, setResults] = useState([]);
	const [error, setError] = useState('');

	useEffect(() => {
		const fetchResults = async () => {
			try {
				const user = JSON.parse(localStorage.getItem('user'));
				if (!user || !user.email) {
					history.push('/login');
					return;
				}
				const response = await fetch(`${config.API_BASE}/results/${user.email}`);
				const data = await response.json();
				setResults(data);
				setLoading(false);
			} catch (error) {
				console.error('Error fetching results:', error);
				setError('Failed to fetch results');
				setLoading(false);
			}
		};

		fetchResults();
	}, [history]);

	const handleNewTest = () => {
		history.push('/usertests');
	};

	if (loading) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
				<CircularProgress />
			</Box>
		);
	}

	if (error) {
		return (
			<Box p={3}>
				<Typography color="error">{error}</Typography>
				<Button
					variant="contained"
					color="primary"
					onClick={handleNewTest}
					style={{ marginTop: '20px' }}
				>
					Take Another Test
				</Button>
			</Box>
		);
	}

	const grouped = groupByTestType(results);
	const themeBox = { background: '#fff', borderRadius: 12, boxShadow: '0 2px 16px rgba(21,28,67,0.06)', marginBottom: 32, padding: 24 };

	return (
		<>
			<UserNav />
			<Box p={3} style={{ maxWidth: 800, margin: '0 auto' }}>
				<Typography variant="h4" gutterBottom style={{ color: '#151c43', fontWeight: 700 }}>
					Your Results
				</Typography>
				{Object.keys(grouped).length === 0 ? (
					<Typography>No test results found.</Typography>
				) : (
					Object.entries(grouped).map(([type, attempts]) => (
						<Box key={type} style={themeBox}>
							<Typography variant="h6" style={{ color: '#1A237E', marginBottom: 12 }}>{type} Results</Typography>
							{attempts.map((result, idx) => (
								<Accordion key={idx} style={{ marginBottom: 8 }}>
									<AccordionSummary expandIcon={<ExpandMoreIcon />}>
										<Typography style={{ flex: 1 }}>
											{new Date(result.createdAt).toLocaleDateString()} — <b>Result:</b> {result.result}
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: 'block' }}>
										<Typography variant="subtitle2" style={{ marginBottom: 8 }}>Detailed Answers:</Typography>
										<List dense>
											{result.questions && result.answers && result.questions.map((q, i) => (
												<ListItem key={i} alignItems="flex-start" style={{ paddingLeft: 0 }}>
													<ListItemText
														primary={<span><b>Q{i + 1}:</b> {q}</span>}
														secondary={<span><b>Your answer:</b> {result.answers[i]}</span>}
													/>
												</ListItem>
											))}
										</List>
									</AccordionDetails>
								</Accordion>
							))}
						</Box>
					))
				)}
				<Button
					variant="contained"
					color="primary"
					onClick={handleNewTest}
					style={{ marginTop: '20px' }}
				>
					Take Another Test
				</Button>
			</Box>
		</>
	);
};

export default Results;
